export default __webpack_public_path__ + "static/media/G_Gato.6db0bf8f.svg";